import { Box, Typography } from "@mui/material";
import { useEffect, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LeftArrowIcon, LogoShapeIconWhite, LogoTextIconWhite } from "../../../assets/icons";
import theme from "../../../theme";
import { useMediaQuery } from "@react-hook/media-query";
import { useLanguage } from "../../../hooks/useLanguage";

interface HeaderProps {
  title: string;
  historyBack?: boolean;
}

export default function Type1({ title, historyBack }: HeaderProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isRTL } = useLanguage();
  const displayHistoryBack = useMemo(() => {
    const routes = "/profile/";
    return pathname.startsWith(routes);
  }, [pathname]);

  return (
    <Box className="mobile-header type1" sx={{ height: "60px", padding: "14px 12px" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {displayHistoryBack || historyBack ? (
          <Box
            onClick={() => (title === "login" ? navigate("/") : navigate(-1))}
            sx={{
              color: "primary.text",
              display: "flex",
              transform: isRTL ? "rotate(180deg)" : "none"
            }}
          >
            <LeftArrowIcon width={24} height={24} />
          </Box>
        ) : null}

        <Typography
          component={"span"}
          sx={{
            fontSize: "20px",
            fontWeight: 600,
            lineHeight: "normal",
            textTransform: "capitalize",
            color: "primary.text",
          }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
}
